import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getMaritalInformationStart,
  getMaritalInformationSuccess,
  getMaritalInformationFailed,
} from "../redux/getMaritalInformation";

import { getMaritalInformationApi } from "core/http/service/personnelInformation";
import { resetFormEditMaritalInformation } from "../redux/formEditMaritalInformation";

function* getMaritalInformationWork() {
  try {
    const res = yield call(getMaritalInformationApi);

    yield put({
      type: getMaritalInformationSuccess.type,
      payload: res,
    });

    yield put({
      type: resetFormEditMaritalInformation.type,
    });
  } catch (error: any) {
    yield put({
      type: getMaritalInformationFailed.type,
    });
  }
}

function* watchGetMaritalInformation() {
  yield takeLatest(getMaritalInformationStart.type, getMaritalInformationWork);
}

export default function* getMaritalInformationSaga() {
  yield all([watchGetMaritalInformation()]);
}
